//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { message } from "ant-design-vue";
import "ant-design-vue/es/message/style/index.css"
import Vue from "vue";
import { DESIGN_VARIANTS } from "@/constants/ui.js";
import cloneDeep from "lodash/cloneDeep"
import TheSwitch from "@/components/objects/public/TheSwitch.vue";

Vue.use(message)
export default {
  name: "TheExportNew",
  components: {
    TheSwitch
  },
  inject: {
    source: {
      default: ''
    },
    module: {
      default: 'table'
    }
  },
  props: {
    showSource: {
      type: Boolean,
      default: false
    },
    showExport: {
      type: Boolean,
      default: true
    },
    showStyles: {
      type: Boolean,
      default: true
    },
    designVariant: {
      type: String,
      required: false
    },
    sourceUrl: {
      type: String
    },
    screenId: {
      type: String
    },
    screenName: {
      type: String
    },
    createScreenShotHandler: {
      type: [Function, null]
    },
    title: {
      type: String
    },
    icon: {
      type: String
    },
    fileName: {
      type: String
    },
    white: {
      type: Boolean,
      default: false
    },
    showDetail: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Boolean,
      default: false
    },
    design: {
      type: String,
    },
    template: {
      type: Object,
    },
    theme: {
      type: String,
    },
    headerColumn: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
    },
    placement: {
      type: String,
      required: false,
      default: 'topLeft'
    },
    rightOffset: {
      type: String,
      default: null
    },
  },

  data() {
    const vistatTemplate = {
      name: 'Vistat',
      styles: null,
      key: 0
    }

    return {
      designValue: this.design,
      themeValue: this.theme,
      templateValue: this.template,
      vistatTemplate: vistatTemplate,
      popoverVisible: false,
    }
  },

  computed: {
    isSource() {
      return this.showSource && this.sourceUrl
    },
    isOnlySource() {
      return this.showSource && this.sourceUrl && !this.showExport && !this.showStyles
    },
    getDesignVariants() {
      return DESIGN_VARIANTS[this.designVariant]
    },
    getDesignSixU() {
      const sixU = ['facts_default', 'green', 'white', 'blue']
      return this.getDesignVariants ? this.getDesignVariants.filter(el => sixU.includes(el.id)) : []
    },
    getDesignFourU() {
      const fourU = ['color']
      return this.getDesignVariants ? this.getDesignVariants.filter(el => fourU.includes(el.id)) : []
    },
    getTemplateVariants() {
      if (this.$auth.loggedIn) {
        return cloneDeep(this.$auth?.user?.profile?.infographic_styles)
      }
      return null
    },
    showTemplates() {
      return this.$auth?.loggedIn && this.$auth?.user?.profile?.use_own_style
    },
    getDesignThemes() {
      const findDesign = this.$store.state["property_templates"]["consts"].design.find(el => el.module === this.module && el.id === this.designValue);
      if (findDesign) {
        return findDesign.themes;
      }

      return null;
    },
    exportItemsStyle() {
      if (!this.rightOffset) {
        return null;
      }

      return { right: this.rightOffset };
    }
  },

  watch: {
    theme: {
      handler(newVal) {
        this.themeValue = newVal
      }
    },
    template: {
      async handler(newVal) {
        if (newVal) {
          this.templateValue = newVal
          await this.$store.dispatch('makeRealtimeExample', {
            elementId: this.screenId,
            title: this.title,
            icon: this.icon,
            store: this.$store,
            styles: newVal?.styles,
            headerColumn: this.headerColumn
          })
        } else {
          this.templateValue = null
        }
      },
      deep: true
    }
  },

  methods: {
    async onChangeDesign(evt) {
      this.$emit('design-change', evt.target.value)

      if (this.templateValue) {
        await this.$store.dispatch('makeRealtimeExample', {
          elementId: this.screenId,
          title: this.title,
          icon: this.icon,
          store: this.$store,
          styles: this.templateValue?.styles,
          headerColumn: this.headerColumn,
        })
      }
    },
    async onChangeTheme(evt) {
      this.$emit('theme-change', evt.target.value)

      if (this.templateValue) {
        await this.$store.dispatch('makeRealtimeExample', {
          elementId: this.screenId,
          title: this.title,
          icon: this.icon,
          store: this.$store,
          styles: this.templateValue?.styles,
          headerColumn: this.headerColumn,
        })
      }
    },
    async onChangeTemplate() {
      this.popoverVisible = false
      this.$emit('template-change', this.templateValue)

      await this.$store.dispatch('makeRealtimeExample', {
        elementId: this.screenId,
        title: this.title,
        icon: this.icon,
        store: this.$store,
        styles: this.templateValue?.styles,
        headerColumn: this.headerColumn,
      })
    },
    doMakeScreenShot() {
      if (this.createScreenShotHandler) {
        return this.createScreenShotHandler({
          styles: this.templateValue?.styles,
          screenId: this.screenId,
          fileName: this.fileName || this.screenName,
          headerColumn: this.headerColumn,
          user: this.user,
          store: this.$store,
          icon: this.icon,
        })
      } else {
        return this.$store.dispatch('makeScreenshotOfSection', {
          elementId: this.screenId,
          fileName: this.fileName || this.screenName,
          title: this.title,
          icon: this.icon,
          store: this.$store,
          user: this.user,
          styles: this.templateValue?.styles,
          headerColumn: this.headerColumn
        })
      }
    },
    handleCreateScreen() {
      new Promise((resolve, reject) => {
        message.loading({ content: 'Создаётся скриншот...', key: 'screen' })

        this.doMakeScreenShot()
          .then(() => {
            message.success({ content: 'Готово!', key: 'screen', duration: 2 });
          })
          .catch((error) => {
            console.error(error)
            message.error({ content: 'Произошла ошибка', key: 'screen' })
          })
      })

      this.$emit('make-screenshot');
    },
    handleSourceGo() {
      if (this.isSource) {
        const link = document.createElement('a');
        const url = new URL(this.sourceUrl, window.location.origin)
        if (['localhost', 'vistat'].some(x => url.origin.includes(x))) {
          link.href = this.sourceUrl + this.source;
        } else {
          link.href = this.sourceUrl;
        }
        link.target="_blank";
        link.click();
      }
    }
  }
}
